module.exports = __webpack_public_path__ + "img/艺考集训@2x.8296e629.png";